import { Dialog, useMediaQuery, useTheme } from "@mui/material";
import { useNotification } from "app/NotificationProvider";
import { mixpanel } from "common/analytics";
import { useTranslation } from "common/locales";
import { StyledInputContainer } from "features/StyledInputContainer";
import {
  GeneralFeedEvent,
  selectCurrentFarm,
  updateFeedEvent,
  useAppDispatch,
  useAppSelector,
} from "model";
import { Dispatch, SetStateAction } from "react";
import EnterFeedEvent from "./EnterFeedEvent";

export default function UpdateFeedEvent({
  feedEvent,
  dialogOpen,
  setDialogOpen,
}: {
  feedEvent: GeneralFeedEvent;
  dialogOpen: boolean;
  setDialogOpen: Dispatch<SetStateAction<boolean>>;
}) {
  const dispatch = useAppDispatch();
  const { notify } = useNotification();
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClose = () => {
    setDialogOpen(false);
    mixpanel.track("Update feed event cancelled");
  };

  const currentFarm = useAppSelector(selectCurrentFarm);

  async function handleSave(generalFeedEvent: GeneralFeedEvent) {
    await dispatch(
      updateFeedEvent({
        generalFeedEvent,
        farmGuid: currentFarm?.guid ?? "",
      })
    );
    notify(t("addFeedEvent.add.success"));
    mixpanel.track("FeedEvent created");
    handleClose();
  }
  return (
    <Dialog
      fullScreen={isMobile}
      maxWidth="md"
      disableEscapeKeyDown
      open={dialogOpen}
      onClose={handleClose}
    >
      <StyledInputContainer isMobile={isMobile}>
        <EnterFeedEvent
          feedEvent={feedEvent}
          handleSave={handleSave}
          handleClose={() => {
            handleClose();
          }}
        />
      </StyledInputContainer>
    </Dialog>
  );
}
